/*
 * @Author: cuihaonan
 * @Email: devcui@outlook.com
 * @Date: 2021-04-07 13:59:18
 * @LastEditTime: 2021-06-08 15:10:01
 * @LastEditors: cuihaonan
 * @Description: Basic description
 * @FilePath: /angular-mobile-npm-package/projects/ng-yunzai-mobile/devices/yiban.ts
 * @LICENSE: NONE
 */

import { BaseDevice } from "./base.device";
import { Inject, Injectable } from "@angular/core";
import { TokenService } from "../token/token.service";
import { HttpClient } from "@angular/common/http";
import { UserService } from "../user/user.service";
import { BaseClient, BASE_CLIENT } from "../client/base.client";
import { preloaderFinished } from "../auth/preloader";
import { Itoken } from "../auth/itoken";
import { Observable } from "rxjs";
import { IShare, ITitle, IWindow, NavigationBar, UserLocation } from "./model";
import { Title } from "@angular/platform-browser";

@Injectable({
  providedIn: "root",
})
export class Yiban extends BaseDevice {
  constructor(
    private tokenService: TokenService,
    private http: HttpClient,
    private user: UserService,
    private title: Title,
    @Inject(BASE_CLIENT) private baseclient: BaseClient
  ) {
    super();
  }

  auth(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      // 查看有无参数
      const params = window.location.href.split("?")[1];
      if (params) {
        // 拿到参数键直对
        const kvs = params.split("&");
        const tokenInfo: any = {};
        // 查看有无token信息
        kvs.forEach((k) => {
          if (k.includes("_token")) {
            tokenInfo["accessToken"] = k.split("=")[1];
            tokenInfo["tokenType"] = "bearer";
          }
        });
        // 如果有token信息
        if (tokenInfo.accessToken) {
          // 设置token信息
          this.tokenService.set(tokenInfo);
          // 请求user
          this.http
            .get(`${this.baseclient.gateway}/auth/user`)
            .subscribe((response: any) => {
              // 设置user
              this.user.set(response.principal);
              // 加载结束
              preloaderFinished();
              resolve(true);
            });
        } else {
          alert("无法获取到易班用户信息参数");
        }
      } else {
        alert("无法获取到易班参数");
      }
    });
  }

  openWindow(iwindow: IWindow): void {
    window.open(iwindow.url);
  }

  setTitle(ititle: ITitle): void {
    this.title.setTitle(ititle.title);
  }

  setNavigationBar(navigationBar: NavigationBar): void {
    alert("易班暂不支持放置按钮,请在APP中使用此功能!");
  }

  share(ishare: IShare): void {
    alert("易班暂不支持分享,请在APP中使用此功能!");
  }

  getToken(): Itoken {
    return this.tokenService.get();
  }

  scanCode(): Observable<string> {
    alert("易班暂不支持扫码,请在APP中使用此功能!");
    return undefined;
  }

  userLocation(): Observable<UserLocation> {
    alert("易班暂不支持定位,请在APP中使用此功能!");
    return undefined;
  }

  validateInWifi(bssids: string[]): Observable<boolean> {
    alert("易班暂不支持WIFI验证,请在APP中使用此功能!");
    return undefined;
  }

  getWifiMac(): Observable<string> {
    alert("易班暂不支持获取MAC地址,请在APP中使用此功能!");
    return undefined;
  }

  chooseContacts(count: number): Observable<any> {
    alert("易班暂不支持获取联系人,请在APP中使用此功能!");
    return undefined;
  }

  contactDetails(targetUserId: string): Observable<any> {
    alert("易班暂不支持查询联系人详细信息,请在APP中使用此功能!");
    return undefined;
  }

  uploadImage(count: number, sourceType: any): Observable<any> {
    alert("易班暂不支持图片上传,请在APP中使用此功能!");
    return undefined;
  }

  openReadWithTimer(
    url: any,
    openType: any,
    title: any,
    id: any,
    type: any
  ): Observable<any> {
    alert("易班暂不支持读物时间统计,请在APP中使用此功能!");
    return undefined;
  }

  uploadMovie(limitMinute: number): Observable<any> {
    alert("易班暂不支持视频上传,请在APP中使用此功能!");
    return undefined;
  }

  fileBrowser(url: string, title: string): Observable<any> {
    alert("易班暂不支持此功能,请在APP中使用此功能!");
    return undefined;
  }

  startSearchBeacons(ticket: string, callback: (argv: any) => void): void {
    throw new Error("Method not implemented.");
  }
  stopSearchBeacons(callback: (argv: any) => void): void {
    throw new Error("Method not implemented.");
  }
  onSearchBeacons(callback: (argv: any) => void): void {
    throw new Error("Method not implemented.");
  }
}
